import { MODEL_NUMBER_COLUMN_WIDTHS } from "./TableModelNumbers.constants"
import type { ColumnsType } from "antd/es/table"
import type { TModelNumberTableRow } from "types/modelNumbers.type"

export const ModelNumbersColumns = (): ColumnsType<TModelNumberTableRow> => {
	return [
		{
			title: "Model numbers",
			dataIndex: "model_number",
			key: "model_number",
			width: MODEL_NUMBER_COLUMN_WIDTHS.modelNumber,
		},
		{
			title: "WIDTH",
			dataIndex: "width",
			key: "width",
			width: MODEL_NUMBER_COLUMN_WIDTHS.width,
		},
		{
			title: "HEIGHT",
			dataIndex: "height",
			key: "height",
			width: MODEL_NUMBER_COLUMN_WIDTHS.height,
		},
		{
			title: "DEPTH",
			dataIndex: "depth",
			key: "depth",
			width: MODEL_NUMBER_COLUMN_WIDTHS.depth,
		},
		{
			title: "MIN SIZE",
			dataIndex: "min_size",
			key: "min_size",
			width: MODEL_NUMBER_COLUMN_WIDTHS.minSize,
			render: (size: string) => (size ? `${size}` : 0),
		},
		{
			title: "AVG SIZE",
			dataIndex: "avg_size",
			key: "avg_size",
			width: MODEL_NUMBER_COLUMN_WIDTHS.avgSize,
			render: (size: string) => (size ? `${size}` : 0),
		},
		{
			title: "MAX SIZE",
			dataIndex: "max_size",
			key: "max_size",
			width: MODEL_NUMBER_COLUMN_WIDTHS.maxSize,
			render: (size: string) => (size ? `${size}` : 0),
		},
	]
}
